//import { decryptToken } from "./encryption";
import { decrypt } from "./encryption";
import { getCurrentLanguage } from "./i18n";

export const setTokenFromQuery = (search: string) => {

    const params = new URLSearchParams(search);
    let token = params.get('token');
    const language = params.get('language');

    if (token) {
        token = token.replaceAll(' ', '+');
        sessionStorage.setItem('token', token);
    }

    if (language) {
        sessionStorage.setItem('language', language.toLowerCase());
    }
};


export const getToken = () => {

    var token = sessionStorage.getItem('token');
    if (token != null) {
        const decryptedToken = decrypt(token);
        return decryptedToken;
    }


};

export const getLanguageId = (): string => {
    if (getCurrentLanguage() === 'en') {
        return '2';
    }

    return '1';
};
